import { render, staticRenderFns } from "./VViewer.vue?vue&type=template&id=1832adb4&scoped=true"
import script from "./VViewer.vue?vue&type=script&lang=js"
export * from "./VViewer.vue?vue&type=script&lang=js"
import style0 from "./VViewer.vue?vue&type=style&index=0&id=1832adb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1832adb4",
  null
  
)

export default component.exports